// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"e4ac8db1","579":"93c10d43","580":"5fdb73a1","838":"86e32e32"}[chunkId] + ".chunk.js";
};